<template>
    <el-drawer
        title="批量推送小红书"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        :show-close="false"
    >
        <div class="drawer-content">
            <el-upload 
                drag 
                action
                :http-request="uploadExcel"
                :auto-upload="false"
                ref="upload"
                accept=".xls, .xlsx"
                :show-file-list="true"
                :before-upload="beforeUpload"
                :file-list="fileList"
                :on-change="onChange"
                :on-remove="onRemove"
                :disabled="uploadLoading"
            >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击选择文件</em></div>
                <div class="el-upload__tip" slot="tip">
                    只能上传xls/xlsx文件，且最多不超过1W行<br>量大时，需要较长时间才能完成全部推送
                </div>
            </el-upload>
            
            <div class="color-info">
                导入文件示例如下:
                <el-button 
                    v-if="$utils.have('/activity/ali/batchPush/template')" 
                    type="text" 
                    icon="el-icon-download" 
                    :loading="downLoading"
                    @click="download">
                    点击下载模板
                </el-button>
            </div>
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                size="small"
            >
                <el-table-column prop="id" label="演出ID"></el-table-column>
                
            </el-table>
            
        </div>
        <div class="drawer-footer">
            <el-button v-if="!btnLoading" @click="close">关闭</el-button>
            <el-button type="primary" @click="submitUpload" :loading="btnLoading" :disabled="canSubmit"
                >提交</el-button>
        </div>
        <ErrorMsgDrawer ref="errorMsgDrawer"></ErrorMsgDrawer>
    </el-drawer>
</template>

<script>
import {downloadFileTmp,uploadFileTmp} from '@/assets/js/commonApi.js';
import ErrorMsgDrawer from '@/components/ErrorMsgDrawer';

export default {
    props:{
        id:{
            type:[Number,String],
            default:1
        }
    },
    data() {
        return {
            drawerShow:false,
            btnLoading: false,
            uploadLoading: false,
            dataList:[{
                id:'220501',
                
            },{
                id:'220502',
                
            }],
            canSubmit:true,
            downLoading:false,
            fileList:[],
			errFilePath:''
        };
    },
    components:{ErrorMsgDrawer},
    methods: {
        show() {
            this.drawerShow = true;
        },
        close(){
            this.fileList = [];
            this.drawerShow = false;
        },
        submitUpload() {
            this.$refs.upload.submit();
        },
        async uploadExcel(req){
            this.btnLoading = true;
            const formData = new FormData();
            formData.append('file', req.file);

            let filePath;
            const res = await uploadFileTmp(formData).catch(err => {
                this.$message({message: err.message, type: 'error'});
            });
            const{state,msg,result} = res.data;
            if (state == 1 && result) {
                filePath = result.url;
            }else{
                this.$message.error(msg || '上传失败');
            }

            this.$request({
                url:'/activity/red/batchPush',
                method: 'post',
                data:{fileUrl:filePath}
            })
                .then(res => {
                    const{state,msg,result} = res.data;
                    if (state == 1) {
                        if(result && result.importErrorDetailVOList.length > 0 && result.errFilePath ){
							this.errFilePath = result.errFilePath
							const _msg = `有<span class="color-danger"> ${result.importErrorDetailVOList.length} </span>场演出推送失败，请下载后酌情修改。`;
							this.$confirm(_msg, '批量推送小红书', {
							    confirmButtonText: '下载有问题的演出',
							    cancelButtonText: '关闭',
							    type: 'warning',
							    center: true,
							    closeOnClickModal: false,
							    dangerouslyUseHTMLString: true,
							}).then(() => {
							    this.downloadErrActivity()
								this.close()
							}).catch(() => {});
                            // this.$refs.errorMsgDrawer.show(result.importErrorDetailVOList);
                        }else{
                            this.onSuccess();
                        }
                        
                    }else{
                        this.$message.error(msg || '上传失败');
                        this.canSubmit = false;
                    }
                })
                .catch(err => {
                    this.$message({message: err.message, type: 'error'});
                    this.canSubmit = false;
                })
                .finally(() => {
                    this.btnLoading = false;
                    //this.$refs.upload.clearFiles();
                    this.canSubmit = true;
                });

        },
		//下载有问题题的演出		
		async downloadErrActivity(){		       
			await downloadFileTmp(this.errFilePath, '推送小红书有问题的演出.' + this.$utils.getFileType(this.errFilePath));		   
		},
        onChange(file){
            if( file ){
                this.fileList = [{...file}]
                this.canSubmit = false;
            }else{
                this.canSubmit = true;
            }
        },
        onRemove(){
            this.canSubmit = true;
        },
        beforeUpload(file){
            const type = this.$utils.getFileType(file.name)
            const isType = type === 'xls' || type === 'xlsx';
            if (!isType) {
                this.$message.error('仅支持xls、xlsx文件格式,请重新选择上传文件!');
            }
            return isType;
        },
        
        onSuccess(){
            this.$emit('update');
            this.close();
        },
        //下载模板
        async download(){
            
            let filePath;
             this.downLoading = true;
            const res = await this.$request({
                url:'/activity/red/batchPush/template',
                method: 'post',
            })
                .catch(err => {
                    this.$message({message: err.message, type: 'error'});
                })
            const{state,msg,result:{url}} = res.data;
            if(state == 1 && url){
                filePath = url;
            }else{
                 this.downLoading = false;
                return this.$message.error(msg || '下载失败');
            }   

            downloadFileTmp(filePath,'批量推送小红书模板.'+this.$utils.getFileType(filePath));
             this.downLoading = false;
        }
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-upload-dragger, 
::v-deep .el-upload{
    width: 100%;
}
.color-info{
    margin-top: 20px;
}
.el-table{
    margin-bottom: 10px;
}
.from-tip{
    max-width: 420px;
    font-size: 12px;
    b{
        color: $--color-theme;
    }
}
</style>